import {
  SUPPLEMENT_STATUS,
  SUPPLEMENT_STATUS_SUCCESS,
  SUPPLEMENT_STATUS_RESET,
  SUPPLEMENT_FILES,
  SUPPLEMENT_FILE_URL
} from '@/store/types'
import axios from '@/store/axios'
const state = {
  bookCode: '',
  exists: false,
  fileNames: null
}

const getters = {
  getSupplementExists: (state) => state.exists,
  getSupplementFileNames: (state) => state.fileNames
}

const actions = {
  [SUPPLEMENT_STATUS]: ({ commit }, bookCode) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/supplement/${bookCode}/status`)
        .then((resp) => {
          // API 성공 시 응답 데이터 처리
          commit(SUPPLEMENT_STATUS_SUCCESS, {
            bookCode,
            supplementStatus: resp.data.result
          })
          resolve(resp) // 결과 반환
        })
        .catch((err) => {
          // API 실패 시 에러 처리
          commit(SUPPLEMENT_STATUS_RESET)
          reject(err) // 에러 반환
        })
    })
  },
  [SUPPLEMENT_FILES]: (_, bookCode) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/supplement/${bookCode}/files`)
        .then((resp) => {
          resolve(resp.data.result)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  [SUPPLEMENT_FILE_URL]: (_, fileId) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/supplement/files/${fileId}/download-url`)
        .then((resp) => {
          resolve(resp.data.result)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
const mutations = {
  [SUPPLEMENT_STATUS_SUCCESS]: (state, { bookCode, supplementStatus }) => {
    // 상태 업데이트
    state.bookCode = bookCode // 응답에 bookCode가 포함되어 있다면 사용
    state.exists = supplementStatus.exists || false
    state.fileNames = supplementStatus.files || null // 응답에서 fileNames 목록
  },
  [SUPPLEMENT_STATUS_RESET]: (state) => {
    state.bookCode = ''
    state.exists = false
    state.fileNames = null
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
